/// <reference path="../types/index.d.ts" />

import '../client_forms/tcasowaevent/style.css';
import FormStructure from './tcasowaevent/form_structure';

export default FormStructure;